import { SET_USER_TYPE, SET_PERMISSION, SET_JOURNEY, SET_ACCESS_LIST, SET_CURRENT_USER, SET_PREFERENCE, SET_SEAT_EXPIRED, CLEAR_ALL } from './activeUserTypes';

export const setUserType = (userType) => ({
    type: SET_USER_TYPE,
    payload: userType
});

export const setPermission = (permission) => ({
    type: SET_PERMISSION,
    payload: permission
});

export const setAccessList = (accessList) => ({
    type: SET_ACCESS_LIST,
    payload: accessList
});

export const setPreference = (preference) => ({
    type: SET_PREFERENCE,
    payload: preference
});

export const setJourney = (journey) => ({
    type: SET_JOURNEY,
    payload: journey
});

export const setCurrentUser = (user) => ({
    type: SET_CURRENT_USER,
    payload: user
});

export const setSeatExpired = (seatExpired) => ({
    type: SET_SEAT_EXPIRED,
    payload: seatExpired
});

export const clearAll = () => ({
    type: CLEAR_ALL
});